"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.define-property.js");
var _scopedstorage = _interopRequireDefault(require("./scopedstorage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StorageBuilder = /*#__PURE__*/function () {
  function StorageBuilder(appId) {
    _classCallCheck(this, StorageBuilder);
    _defineProperty(this, "appId", void 0);
    _defineProperty(this, "persisted", false);
    _defineProperty(this, "clearedOnLogout", false);
    this.appId = appId;
  }
  _createClass(StorageBuilder, [{
    key: "persist",
    value: function persist() {
      var _persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.persisted = _persist;
      return this;
    }
  }, {
    key: "clearOnLogout",
    value: function clearOnLogout() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearedOnLogout = clear;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return new _scopedstorage.default(this.appId, this.persisted ? window.localStorage : window.sessionStorage, !this.clearedOnLogout);
    }
  }]);
  return StorageBuilder;
}();
exports.default = StorageBuilder;
//# sourceMappingURL=storagebuilder.js.map